import {
    ajax
} from "@/plugins/axios";

export const url = {
    list: "/api/get_toy_lend_list",
    toy_info: "/api/get_toy_info",
    add: "/api/add_toy_lend",
    edit: "/api/return_toy_lend",
    delete: "/api/delete_toy_lend",
    toyCarToLend: "/api/toy_car_to_lend",
    getusers: "/api/get_users",
    returnAllLend: "api/return_all_toy_lend",
    deleteAllLend: "api/delete_all_toy_lend",
};

export const lend = {
    getusers: () => {
        return ajax.post(
            url.getusers,
            null
        );
    },
    list: (param) => {
        return ajax.post(
            url.list,
            param
        );
    },
    toyinfo: (param) => {
        return ajax.post(
            url.toy_info,
            param
        );
    },
    add: (param) => {
        return ajax.post(
            url.add,
            param
        );
    },
    edit: (param) => {
        return ajax.post(
            url.edit,
            param
        );
    },
    delete: (param) => {
        return ajax.post(
            url.delete,
            param
        );
    },
    toyCarToLend: (param) => {
        return ajax.post(
            url.toyCarToLend,
            param
        )
    },
    returnAllLend: (param) => {
        return ajax.post(
            url.returnAllLend,
            param
        )
    },
    deleteAllLend: (param) => {
        return ajax.post(
            url.deleteAllLend,
            param
        )
    }
}